<template>
  <div>
   <div class="vl-parent">
    <loading v-model:active="isLoading"
    :can-cancel="true"
    :is-full-page="fullPage"/>
   </div>
  <h3 style="background:#007bff;; padding: 10px; line-height: 42px; text-align: center; color: #fff;">Federation General Information</h3>
             <form class="fed_search" @submit.prevent="searchfederation()">
              <div class="form-group col-md-4">
                <label for="">Federation Name</label>
                <input type="text" class="form-control" v-model="federation" @input="searchInput"   placeholder="Federation Name">
               <div class="productlist" v-if="federationok" ref="suggestionsList">
                <ul>
                 <li @click="selectfederation(federation.FederationName)" v-for="federation in this.federationlist">{{federation.FederationName}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-3">
                 <label for="">District</label>
                <input type="text" class="form-control" v-model="district" @input="districtInput"  placeholder="District Name">
                <div class="productlist2" v-if="districtok" ref="suggestionsList2">
                <ul>
                 <li @click="selectdistrict(district.District)" v-for="district in this.districtlist">{{district.District}}</li>
                 </ul>
               </div>
              </div>
              <div class="form-group col-md-3">
                 <label for="">Upazila</label>
                <input type="text" class="form-control" v-model="upazila" @input="upazilaInput"  placeholder="Upazila Name">
                <div class="productlist3" v-if="upazilaok" ref="suggestionsList3">
                <ul>
                 <li @click="selectupazila(upazila.Upazila)" v-for="upazila in this.upazilalist">{{upazila.Upazila}}</li>
                 </ul>
               </div>
              </div>
               <div class="form-group col-md-2">
                <button type="submit" class="fed_search_btn"><i class="fa fa-search"></i> Search</button>
              </div>
              
   </form>
  <div class="table-responsive">
       <table id="order-listing" class="table">
           <thead>
               <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>District</th>
                  <th>Upazila</th>
                  <th>Village</th>
                  <th>P.O</th>
                  <th>F Year</th>
                  <th>F Headed</th>
                  <th>Chairman Name/Mobile number</th>
                  <th>Atcion</th>
               </tr>
           </thead>
               <tbody>
                  <tr v-for="(federation,index) in this.generalinformations"> 
                    <td style="width:20px!important;">{{index+1}}</td> 
                    <td>{{federation.FederationName}}</td> 
                    <td>{{federation.District}}</td> 
                    <td>{{federation.Upazila}}</td> 
                    <td>{{federation.Village}}</td> 
                    <td>{{federation.PostOffice}}</td> 
                    <td>{{federation.FederationFormationYear}}</td> 
                    <td>{{federation.FemaleHeaded}}</td> 
                    <td>{{federation.NameofCurrentFederationChairman}}<br>{{federation.MobilenumberofCurrentFederationChairman  }}</td> 
                    <td>
						   <div class="dropdown">
						    <button @click="toggleDropdown" class="dropdown-button">Actions</button>
						    <div class="dropdown-content" v-show="isOpen">
						      <a v-if="this.edit" href="#" @click.prevent="editAction(federation)"><i class="fa fa-edit"></i> General Information</a>

               

						      <a v-if="this.delete" href="#" @click.prevent="deleteAction(federation.id)"><i class="fa fa-trash"></i> Delete</a>
						      <a :href="url+'viewfederation/'+federation.id" @click="viewAction"><i class="fa fa-eye"></i> View</a>
						    </div>
						  </div>	
              </td> 
            </tr> 
          </tbody>
       </table> 
       <br><br><br><br><br>
	   <transition name="modal">
		     <div v-if="showModal" class="vmodal">
		      <div class="modal-content">
		        <span @click="closeModal" class="close">&times;</span>
		        <p>Are you sure you want to delete it?</p>
		         <div class="buttons">
		            <div class="right">
		              <button @click="deleteItem" type="button" class="btn btn-danger btn-fw">Delete</button>&nbsp;&nbsp;
		              <button @click="closeModal" type="button" class="btn btn-info btn-fw">Cancel</button>
		            </div>
		          </div>
		      </div>
		    </div>
		 </transition>












     <transition name="slide-fade" @enter="handleEnter">
      <div class="modal-mask2 popup" v-show="show2" >
        <div class="modal-wrapper2">
          <div class="modal-container2">
            <div class="modal-header">
              <h4 style="text-align:right;cursor:pointer;" @click="show2 = false"><i class="fa fa-times-circle"></i></h4>
              <slot name="header">
                 Edit Federation Information
              </slot>
            </div>
            <div class="modal-body">
              <div class="wrappermodel">
              <div class="lefside">
                <span>Name</span>
                 <input type="text" id="recivedamount" v-model="federationname"  class="form-control"><br>
                 <select class="form-control" @change="changedistrict($event)" v-model="districtid">
                   <option value="0" selected>Select District</option>
                   <option :value="district.id" v-for="district in this.districtslist">{{district.districtname}}</option>
                 </select><br>
                 <select class="form-control" @change="changeupazila($event)" v-model="upazilaid">
                   <option value="0" selected>Select Upazila</option>
                   <option :value="upazila.id" v-for="upazila in upazilalist">{{upazila.Upazila}}</option>
                 </select>
                 <span>Village</span>
                  <input type="text" v-model="village"   class="form-control">
                  <span >Post Office</span>
                  <input type="text"   class="form-control" v-model="postoffice">
                  <span>Lat</span>
                   <input class="form-control"  type="text" v-model="lat">
              </div>
              <div class="rightside">
                  <span >Formation Year</span>
                  <input type="text"   class="form-control" v-model="formationyear">
                  <span >Female Headed</span>
                  <input type="text"   class="form-control" v-model="femaleheaded">
                  <span >Federation Chairman</span>
                  <input type="text"   class="form-control" v-model="federationchairman">
                  <span >Mobile number</span>
                  <input type="text"   class="form-control" v-model="mobilenumber">
                  <span >Search Federation name</span>
                  <input 
                  type="text" 
                  id="autocomplete" 
                  placeholder="Enter a location" 
                  class="location-input"
                 />
                 <span>Lng</span>
                <input type="text"  class="form-control" v-model="lng">

              </div>
            </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="updategeneralinformation()">
                  Update Information
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
     </transition>


    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default{
  props:['edit','delete'],
  components: {
    Loading
  },
  data(){
    return{

      RegistrationNumber:'',
      RegistrationReceivedfrom:'',
      If_Dont_is_applied_for_registration_YesNo:'',
      If_applied_name_of_the_organization_DSSDYD_DCDWA:'',
      Date_of_application_deposited:'',
      Present_status:'',

      Male_Group:'',
      Female_Group:'',
      Total:'',

      Male:'',
      FeMale:'',
      Total:'',

     federationid:1,
     generalinformations:[],
     searchproduct:'',
     federationlist:[],
     federationok:false,
     suggestion:false,
     federation:'',
     district:'',
     districtok:false,
     districtlist:[],
     upazilaok:false,
     upazilalist:[],
     upazila:'',
     isLoading: false,
     fullPage: true,
     isOpen: false,
     showModal: false,
     deleteid:0,
     show2:false,
     show3:false,
     show4:false,
     show5:false,
     show6:false,
     show9:false,
     federationname:'',
     village:'',
     postoffice:'',
     formationyear:'',
     femaleheaded:'',
     federationchairman:'',
     mobilenumber:'',
     districtslist:[],
     upazilalist:[],
     upazilaname:'',
     districtname:'',
     districtid:0,
     upazilaid:0,
     generalinformationid:0,
     generalinformationregistraionid:0,
     federationgeneralmemberid:0,
     generalcommitteememberid:0,
     executivecommitteememberid:0,
     federationgroupid:0,
      placeDetails: null,
      lat:0,
      lng:0,

    }
  },
  computed:{
    url(){
      return this.$store.state.url;
    }

  },
  mounted(){
    this.getallfederations();
    this.getalldistrict();
    document.addEventListener('click', this.pageClick);
    this.getallpazila();
    this.initAutocomplete();
    // this.loadGoogleMaps();
    
  },
  beforeUnmount() {
      document.removeEventListener('click', this.pageClick);
  },
  methods:{
        handleEnter() {
      this.$nextTick(() => {
        this.initAutocomplete();
      });
    },
    //  loadGoogleMaps() {
    //   if (window.google && window.google.maps) {
    //     this.initAutocomplete();
    //   } else {
    //     const script = document.createElement("script");
    //     script.src =
    //       "https://maps.googleapis.com/maps/api/js?key=AIzaSyBJL6k99xYyzgjdBXmI-JdS5Ph5V-j42jU&libraries=places";
    //     script.async = true;
    //     script.defer = true;
    //     script.onload = () => {
    //       this.initAutocomplete();
    //     };
    //     document.head.appendChild(script);
    //   }
    // },

  initAutocomplete() {
      const input = document.getElementById("autocomplete");
      if (!input) {
        console.error("Autocomplete input not found!");
        return;
      }

      const autocomplete = new google.maps.places.Autocomplete(input);
      // Add listener to detect place selection
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          console.error("No details available for input: " + place.name);
          return;
        }
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();

        this.placeDetails = {
          lat: this.lat,
          lng: this.lng,
        };

        console.log("Selected Place:", this.placeDetails);
      });
      setTimeout(() => {
       document.querySelector(".pac-container").style.zIndex = "9999";
      }, 500);
    },









  updategeneralinformation(){
    this.isLoading = true;
    axios.post(this.url+'updatefederationinformation',{
    federationname:this.federationname,
    village:this.village,
    postoffice:this.postoffice,
    formationyear:this.formationyear,
    femaleheaded:this.femaleheaded,
    federationchairman:this.federationchairman,
    mobilenumber:this.mobilenumber,
    upazilaid:this.upazilaid,
    upazilaname:this.upazilaname,
    districtname:this.districtname,
    districtid:this.districtid,
    generalinformationid:this.generalinformationid,
    lat:this.lat,
    lng:this.lng,
    }).then(response=>{
       this.isLoading = false;
        toast.success("Federation information has updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

        this.getallfederations();

    })

  },
  changedistrict(event){
    this.districtid=event.target.value;
    this.districtname=event.target.options[event.target.options.selectedIndex].text;
    console.log(this.districtname);
  },
  changeupazila(event){
     this.upazilaid=event.target.value;
     this.upazilaname=event.target.options[event.target.options.selectedIndex].text;
     console.log(this.upazilaname);
  },
  getalldistrict(){
    axios.get(this.url+'getalldistrict').then(response=>{
     this.districtslist=response.data;
     console.log(this.districtslist);

    })
  },
  getallpazila(){
    axios.get(this.url+'getallpazila').then(response=>{
     this.upazilalist=response.data;
     console.log(this.upazilalist);

    })
  },

  searchfederation(){
      if(this.district=='Rangpur'){
        this.federationid=1;
      }
      if(this.district=='Dinajpur'){
        this.federationid=2;
      }
      if(this.district=='Thakurgaon'){
       this.federationid=3;
      }
      if(this.district=='Panchagarh'){
       this.federationid=4;
      }
      if(this.district=='Nilphamari'){
       this.federationid=5;
      }
      if(this.district=='Lalmonirhat'){
       this.federationid=6;
      }
      if(this.district=='Kurigram'){
       this.federationid=7;
      }
      if(this.district=='Gaibandha'){
       this.federationid=8;
      }
      this.isLoading = true;
      if(this.federation=='' && this.district=='' && this.upazila==''){
        toast.warning("Please insert at least one input field!", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.isLoading = false;
      }else{
        axios.post(this.url+'searchfederation',{
          federation:this.federation,
          district:this.district,
          upazila:this.upazila

        }).then(response=>{

           setTimeout(() => {
           this.isLoading = false;
           this.generalinformations=response.data;
           this.federation='';
           this.district='';
           this.upazila='';
           },1000)


        })

      } 
  },
  pageClick(event){
      if (
           event.target !== this.$refs.inputField &&
           event.target !== this.$refs.suggestionsList &&
           event.target !== this.$refs.suggestionsList2 &&
           event.target !== this.$refs.suggestionsList3 
           ) {
            this.federationok = false;
            this.districtok=false;
            this.upazilaok=false;
            this.suggestion=false;
            this.suggestion2=false;
            this.suggestion3=false;
   }
   },
   searchInput(event){
      var federationname=event.target.value;
      if(federationname==''){
      this.federationlist=[];
      }else{
        axios.get(this.url+'getfederationlist/'+federationname).then(response=>{
                this.federationlist=response.data;
         console.log(this.federationlist);
        })
        this.federationok=true;

      }

    },
    districtInput(event){
      var districtname=event.target.value;
      if(districtname==''){
      this.districtlist=[];
      }else{
        axios.get(this.url+'getdistrictlist/'+districtname).then(response=>{
                this.districtlist=response.data;
         console.log(this.districtlist);
        })
        this.districtok=true;

      }

    },
    upazilaInput(event){
      var upazila=event.target.value;
      if(upazila==''){
      this.upazila=[];
      }else{
        axios.get(this.url+'getupazila/'+upazila).then(response=>{
                this.upazilalist=response.data;
         console.log(this.upazila);
        })
        this.upazilaok=true;

      }

    },
    selectfederation(federationname){

      this.federation=federationname;

    },
    selectdistrict(districtname){
      this.district=districtname;
    },
    selectupazila(upazila){
      this.upazila=upazila;
    },
    getallfederations(){
    axios.get('/getfederation/'+this.federationid).then(response=>{
      this.generalinformations=response.data;
      console.log(this.generalinformations);
     });
   },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },






    editAction(federation) {
      this.federationname=federation.FederationName;
      this.village=federation.Village;
      this.postoffice=federation.PostOffice;
      this.formationyear=federation.FederationFormationYear;
      this.femaleheaded=federation.FemaleHeaded;
      this.federationchairman=federation.NameofCurrentFederationChairman;
      this.mobilenumber=federation.MobilenumberofCurrentFederationChairman;
      this.upazilaid=federation.upazila_id;
      this.upazilaname=federation.Upazila;
      this.districtname=federation.District;
      this.districtid=federation.district_id;
      this.generalinformationid=federation.id;
      this.lat=federation.lat;
      this.lng=federation.lng;
      this.$emit('edit');
      this.isOpen = false;
      this.show2=true;
     
    },
    deleteAction(federationid) {
      this.deleteid=federationid;
      this.isOpen = false;
      this.showModal = true;
    },
    viewAction() {
      this.$emit('view');
      this.isOpen = false;
    },
    closeModal() {
      this.showModal = false;
    },
    deleteItem() {
      this.closeModal();
      axios.post(this.url+'deletefederation',{
      	id:this.deleteid,
      }).then(response=>{
      	toast.success("Federation deleted successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

        this.getallfederations();

      })
    },
    
  },
  watch:{

       show2(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container2').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container2').style.transform = 'translateY(-100%)';
          }
         });
        },


        


    }
}
</script>
<style scoped>
 .productlist,.productlist2,.productlist3
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul,.productlist2 ul,.productlist3 ul{
    list-style: none;
    background: rgb(0, 123, 255);
  }
  .productlist ul li,.productlist2 ul li,.productlist3 ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  .table-responsive{
  	overflow-x: hidden;
  }
  </style>
<style>
 form.fed_search {
    background: #3a3f51;
    display: block;
    width: 100%;
    float: left;
    padding: 15px;
    color: #fff;
    display: flex;
}
.fed_search_btn {
    background: #007bff;
    position: relative;
    top: 24px;
    padding: 5px 5px;
    line-height: 30px;
    border: 0px;
    width: 100%;
    color: white;
    font-size: 0.875rem;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  min-width: 160px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown-button {
  background-color: rgb(0, 123, 255);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}
</style>
<style scoped>
.vmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  width:50%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}

.button {
  margin-top: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  text-align: right;
}

.modal-enter-active, .modal-leave-active {
  transition: transform .5s ease-in, opacity .5s ease-out;
  transform: translateY(-50%);
  opacity: 1;
}
.modal-enter, .modal-leave-to /* .modal-leave-active in <2.1.8 */ {
  transform: translateY(-50%);
  opacity: 0 opacity .5s ease-out;
}

</style>
<style>
  .modal-mask2{
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper2{
    display: table-cell;
    vertical-align: middle;
  } 

  .modal-mask9{
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper9{
    display: table-cell;
    vertical-align: middle;
  } 



  .modal-wrapper3 ,.modal-wrapper4 ,.modal-wrapper5 ,.modal-wrapper6 {
    display: table-cell;
    vertical-align: middle;
  } 
  .modal-container2{
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}

.modal-container3, .modal-container4,.modal-container5 ,.modal-container6 ,.modal-container9{
  width:80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}

.modal-container9{
  width:33%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}

.modal-header {
    padding: 5px!important;
    border-bottom: 1px solid #e5e5e5;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}
.wrappermodel{
  display: flex;

}
.lefside{
  width:48%;
  float:left;
  padding-right:10px;
}
.rightside{
   width:48%;
  float:left;
}
.modal-default-button{
  background: #007bff;
  border: 1px solid #007bff;
  color: white;
}
</style>

<style scoped>
.location-input {
  width: 100%;
  padding: 8px;
font-size: 16px;
z-index:999999999999999999999999!import;
}
.pac-container {
  z-index: 9999 !important; 
}

</style>